import { useAuthContext } from '~/src/context/AuthProvider'
import useAuthUser from '~/src/hooks/useAuthUser'
import { cn } from '~/src/lib/utils'

interface Props extends React.HTMLAttributes<HTMLDivElement> {}

const AuthButtons: React.FC<Props> = ({ className }) => {
  const { loading, authUserNotAnonymous } = useAuthUser()
  const { openAuthModal } = useAuthContext()

  if (loading || authUserNotAnonymous) return null

  return (
    <button
      className={cn(
        'flex animate-fade-in items-center gap-3',
        'h-10 rounded-full bg-black/5 px-4 text-sm font-semibold transition-colors hover:bg-black/10 dark:bg-white/10 dark:hover:bg-white/20',
        className
      )}
      onClick={() =>
        openAuthModal({
          source: 'header-signup',
        })
      }
    >
      Sign up
    </button>
  )
}

export default AuthButtons
